import React, { useEffect, useRef, useState } from "react";

// Context
import { useAuthContext } from "../context/AuthContext";
import { useCartContext } from "../context/CartContext";

// Imports
import Navbar from "./Navbar";
import NavigationBar from "./NavigationBar";
import Footer from "./Footer";
import AuthComponent from "./AuthComponent";
import CartComponent from "./CartComponent";
import Notification from "./Notification";
import TCPP from "./TC&PP";
import TC from "./T&C";

const navigationLinks = [
	{ title: "My Profile", link: "/my-profile" },
	{ title: "My Order", link: "/my-order" },
	{ title: "Family Member", link: "/family-member" },
	{ title: "My Address", link: "/my-address" },
	{ title: "Support", link: "/support" },
];

const SimpleWrapper = ({
	children,
	navigation = true,
	searchVisible,
	locationVisibility,
}) => {
	const { notificationData, isAuth, isTCPP, isTC } = useAuthContext();
	const { isCart } = useCartContext();
	const [isLocationClicked, setIsLocationClicked] = useState(false);

	const navbarRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (navbarRef.current && !navbarRef.current.contains(event.target)) {
				setIsLocationClicked(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<>
			<div className='w-full h-fit bg-whiteColor pt-[15%] lg:pt-[5%]'>
				<div ref={navbarRef}>
					<Navbar
						searchVisible={searchVisible}
						locationVisibility={locationVisibility}
						locationCardStatus={isLocationClicked}
						locationCardVisibility={setIsLocationClicked}
					/>
				</div>
				{navigation && (
					<div className='w-full h-fit px-[25%] mt-[1%] mb-[3%] hidden lg:block'>
						<NavigationBar navigationLinks={navigationLinks} />
					</div>
				)}
				<div className='w-full h-fit bg-whiteColor flex flex-col justify-start items-center space-y-[10%] lg:space-y-[5%] px-[3%] pb-[7.5%] lg:px-[10%] lg:pb-[3%]'>
					{children}
				</div>
				{isTCPP && <TCPP />}
				{isTC && <TC />}
				<Footer />
			</div>

			{isAuth && <AuthComponent />}
			{isCart && <CartComponent />}
			{notificationData?.message?.length > 0 && <Notification />}
		</>
	);
};

export default SimpleWrapper;
